module.exports = __webpack_public_path__ + "img/logo-the-intercept.246ffb6d.svg";